import { route } from "../vars";

const currentPathname = window.location.pathname;
if (!currentPathname.includes(route.basename)) {
  window.history.replaceState("", "", route.basename + currentPathname);
}
